// Document downloading util which allows a user to download a document via a presigned url API call

import { CaseDocument, CaseDocumentAdmin } from "pwapi";

//   The fileName is what the document will be called via the download
export const downloadDocument = async (
  presigned_url: string,
  fileName: string,
  extension?: string
) => {
  const response = await fetch(new Request(presigned_url));
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName || "Document"}${extension || ""}`);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
};

// Creates a document label based on a document category. Fish is incorrectly defined in the enum so it will be autogenerated to FISH
export const getDocumentLabel = (
  category: CaseDocument.category | CaseDocumentAdmin.category
) => {
  if ((category as CaseDocument.category) === CaseDocument.category.FISH_REPORT)
    return "FISH Report";
  return category.replaceAll("-", " ");
};
